<menu-toggle [active]="active" [contrast]="contrast" (click)="setActive()"></menu-toggle>

<div class="wrapper" [class.active]="active">
  <user-menu-main [user]="data"></user-menu-main>
  <ng-container *ngTemplateOutlet="sidebar"></ng-container>
  <div class="m-2 line"><br/></div>
  <menu-item
    titleItem="Support"
    i18n-titleItem="@@mobileMenu.support"
    [link]="links.support[locale]"
    externalUrl="true"
    icon="icon-i-support"
    class=""
  ></menu-item>
  <user-menu-navigation [isSmallMenu]="false" [currency]="data?.preferences?.fiatCurrencyCode"></user-menu-navigation>
</div>
<div class="overlay" [class.active]="active" (click)="setActive(false)"></div>

<ng-template #sidebar>
  <nav>
    <ul class="sidebar">
      <menu-item
        titleItem="Lite Exchange"
        i18n-titleItem="@@menu.lite"
        link="/page/lite"
        icon="icon-i-lite"
      ></menu-item>

      <menu-item
        titleItem="Pro Trading"
        i18n-titleItem="@@menu.pro"
        link="/page/pro"
        icon="icon-i-pro"
      ></menu-item>

      <menu-item
        titleItem="API"
        i18n-titleItem="@@mobileMenu.api"
        [link]="links.apiDocs"
        icon="icon-i-api"
        externalUrl="true"
      ></menu-item>

      <menu-item
        titleItem="Prices"
        i18n-titleItem="@@mobileMenu.prices"
        link="/prices"
        icon="icon-i-prices"
      ></menu-item>

      <menu-item
        link="/page/vip"
        icon="icon-i-vip"
      >
        <span *ngIf="!data?.vip" i18n="@@mobileMenu.nonvip">Become a VIP</span>
        <span *ngIf="data?.vip" i18n="@@mobileMenu.vip">My VIP benefits</span>
      </menu-item>

      <menu-item
        titleItem="OTC"
        i18n-titleItem="@@mobileMenu.otc"
        link="/otc"
        icon="icon-i-concierge"
      ></menu-item>

      <menu-item
        titleItem="About Us"
        i18n-titleItem="@@menu.aboutUs"
        link="/about-us"
        icon="icon-i-info"
      ></menu-item>

      <menu-item
        titleItem="Fees"
        i18n-titleItem="@@menu.fees"
        link="/page/fees"
        icon="icon-i-fee"
      ></menu-item>
  
      <menu-item
        titleItem="Blog"
        i18n-titleItem="@@menu.blog"
        [link]="links.blog"
        externalUrl="true"
        icon="icon-i-blog"
      ></menu-item>
    </ul>
  </nav>
</ng-template>